export default function () {
  const widgetName = 'inducteesCards';
  const widgetOpts = inducteesCardsOpts;
  let windowSize = $(window).width();
  let breakpoint = 800;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      $(`#${widgetName} .card-widget-item`).each(function (x) {
        const widgetData = data.items[x];
        $(this).find('.image-container').append(`<div class="abstract-img"></div>`);
        $(this).find('.image-container').append(`<div class="abstract-img-mobile"></div>`);
        $(this).append(`
        <div class="overlay">
          <div class="overlay-border">
            <span class="overlay-title">${widgetData.Title}</span>
            <span class="overlay-description">${widgetData.Description}</span>
            <a class="button" href="${widgetData.URL}">More</a>
          </div>
        </div>
        `);
        $(this).removeAttr('target');
        $(this).find('.card-content').empty();
        $(this).find('.card-content').append(`
          <div class="inner-content">
              <img class="content-logo" src="${CLIENTRESOURCEPATH}dist/images/main-logo.png" alt="${widgetData.Title}"/>
              <span class="content-separator"></span>
              <span class="content-title">${widgetData.Title}</span>
          </div>
          `);

        if (data.items[x].URL == null && data.items[x].Description == '') {
          $(this).addClass('void-link-all');
        }

        if (data.items[x].URL == null) {
          $(this).removeAttr('href');
          $(this).find('.button').remove();

          if (windowSize > breakpoint) {
            $(this).addClass('void-link');
          }
        }
      });
    },
    link: windowSize < breakpoint ? ['all'] : [''],
    maxItemsVisible: 8,
    itemsPerPanel: 8,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    showDescription: false,
    textOverImage: false,
    buyNowButton: false,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
  });
}
